import { useMemo } from 'react';
import { useSelector } from 'react-redux';

export const useCategoryPromotion = (data, node, isSearchPage) => {
  const { globalPromoTiles } = useSelector((state) => state['demo-common']);

  const isDateInRange = useMemo(() => {
    const currentDate = new Date();
    const startDate = globalPromoTiles?.startDate ? new Date(globalPromoTiles?.startDate) : new Date();
    const endDate = globalPromoTiles?.endDate
      ? new Date(globalPromoTiles?.endDate)
      : new Date(new Date().setFullYear(new Date().getFullYear() + 1));
    const rangeValid = currentDate >= startDate && currentDate <= endDate;

    if (!rangeValid) {
      return false;
    }

    if (globalPromoTiles?.applyCondition === 'apply') {
      return globalPromoTiles?.categories?.some((x) => x?.categoryNode?.target === node?.nodeId);
    }

    if (globalPromoTiles?.applyCondition === 'exclude') {
      return globalPromoTiles?.categories?.every((x) => x?.categoryNode?.target !== node?.nodeId);
    }

    return true;
  }, [globalPromoTiles]);

  const categoryData = useMemo(() => {
    if (!isSearchPage && globalPromoTiles?.promoTile?.length > 0 && isDateInRange) {
      const promosArr = globalPromoTiles?.overrideEverything
        ? globalPromoTiles.promoTile
        : [...globalPromoTiles.promoTile, ...data.promoTile];
      return {
        ...data,
        promoTile: promosArr,
      };
    }

    return data;
  }, [isDateInRange, globalPromoTiles, data]);

  return { categoryData };
};